function exportFilesWrapper (data) {
    return data;
}

export default exportFilesWrapper;